import { useContext } from "react";
import { Container } from "reactstrap";

//Common
import FormBackGround from "../../../common/Forms/FormBackGround/FormBackGround";
import FormHeader from "../../../common/Forms/FormHeader/FormHeader";
import DisplayData from "../../../common/DisplayData/DisplayData";
import BlockIcon from "../../../common/Icons/BlockIcon";
import ActivateIcon from "../../../common/Icons/ActivateIcon";
import Button from "../../../common/VFX-UI/Button/Button";

//App
import useComponentGeneralStyles from "../../../styles";
import { EMPTY_GUID } from "../../../../utility/constants";
import { LookupValueViewProps } from "../../../../types/lookupValue";
import { LookupValueContext } from "./LookupValueContainer";

const LookupValueView = (props: LookupValueViewProps) => {
    const {
        onClose,
        editAction,
        toggleActivateHandler,
        toggleDeactivateHandler,
    } = props;
    const lookupValueContext = useContext(LookupValueContext);
    const generalStyles = useComponentGeneralStyles();

    const lookupValue = lookupValueContext?.data;

    const lookupType = lookupValueContext?.lookupTypes?.find(
        (lookupType) =>
            (lookupType as Record<string, string>)["value"] === lookupValue?.typeId
    );

    const lookupGroup = lookupValueContext?.lookupGroup?.name;

    return (
        <FormBackGround>
            <FormHeader
                title={lookupValue?.name}
                onClose={onClose}
                editActionHandler={lookupValue?.isActive? editAction : undefined}
            />
            <>
                {/*<DisplayData text="Name" importedData={lookupValue?.name}></DisplayData>*/}
                <DisplayData
                    text="Description"
                    importedData={lookupValue?.description}
                ></DisplayData>
                <DisplayData
                    text="Category"
                    importedData={(lookupType as Record<string, string>)["label"]}
                ></DisplayData>
                <DisplayData text="Display Order" importedData={lookupValue?.sortValue}></DisplayData>
                {/*<DisplayData*/}
                {/*  text="Lookup Group"*/}
                {/*  importedData={lookupGroup}*/}
                {/*></DisplayData>*/}
            </>
            <div className="border-top container-fluid p-3  mt-auto">
                {lookupValue?.id &&
                lookupValue?.id !== EMPTY_GUID &&
                lookupValue?.isActive && (
                    <>
                        <Button
                            className="me-3"
                            style={generalStyles.deleteButton}
                            onClick={toggleDeactivateHandler}
                        >
                            <BlockIcon />
                        </Button>
                    </>
                )}
                {lookupValue?.id &&
                lookupValue?.id !== EMPTY_GUID &&
                !lookupValue?.isActive && (
                    <Container>
                        <Button
                            style={generalStyles.activateButton}
                            onClick={toggleActivateHandler}
                        >
                            <ActivateIcon />
                        </Button>
                    </Container>
                )}
            </div>
        </FormBackGround>
    );
};

export default LookupValueView;
